<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-app>

        <LoadingComponent :isLoading="$store.getters.loadingModal"/>
        <LoginModal/>
        <ErrorPopup/>
        <ParticipationModal/>
        <v-app-bar
                app
                clipped-left
                color="primary"
                dark
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-row style="text-align: left;">
                <v-col cols="5">
                  <v-img :src="require('./assets/Eudoxus_Publisher_Logo_white_Gr.png')" style=" max-height:50px; max-width:200px" contain alt=""></v-img>
                </v-col>
            </v-row>


            <v-row>
                <v-col class="text-center title">
                    {{$store.getters.homePageInformation.publisherName}}
                </v-col>
            </v-row>

            <v-spacer></v-spacer>

            <v-btn color="secondary" @click="logout">
                <v-icon>exit_to_app</v-icon>
                ΑΠΟΣΥΝΔΕΣΗ
            </v-btn>

        </v-app-bar>
        <v-navigation-drawer
                class="elevation-3"
                app
                clipped
                fixed
                v-model="drawer">
            <br/>
            <v-list dense>
                <v-list-item
                        :disabled="navigationItem.disabled"
                        :key="j"
                        @click="linkToOtherPage(navigationItem)"
                        :class="navigationItem.link === navigationPath ? 'default-class elevation-6 pa-1' : 'pa-1'"
                         ripple v-for="(navigationItem, j) in $store.getters.navigationItems">
                    <v-layout row>
                        <v-list-item-action>
                            <v-icon class="ml-6">{{navigationItem.icon}}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{navigationItem.label}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-layout>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-content class="mt-5">
            <router-view></router-view>
        <Footer/>
        </v-content>
    </v-app>
</template>

<script>
    import HelloWorld from './components/HelloWorld';
    import Footer from "./components/Footer";
    import LoadingComponent from "./components/LoadingComponent";
    import LoginModal from "./components/LoginModal";
    import requests from "./requests"
    import utils from './utilities'
    import {eventBus} from "./main";
    import ParticipationModal from "./components/ParticipationModal";
    import ErrorPopup from "./components/ErrorPopup";

    export default {
        name: 'App',

        components: {
            ErrorPopup,
            ParticipationModal,
            LoadingComponent,
            Footer,
            HelloWorld,
            LoginModal,
        },

        data: () => ({
            navigationPath: '/',
            drawer: null,
            homeInformation: {}
        }),
        methods: {

            // route to another component
            linkToOtherPage(item) {
                if (this.navigationPath != item.link) {
                    this.navigationPath = item.link;
                    this.$router.push({path: item.link});
                }
            },

            //Logout Application
            logout() {

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    requests.logout(token, this.logoutCallBack);
                }
                else {
                    this.removeTokenFromBrowser();
                    this.$store.commit('setloginModal', true);
                }
            },

            logoutCallBack(response) {

                this.$store.commit('setLoadingModal', false);
                this.removeTokenFromBrowser();
                this.$router.push({path: '/'})
            },

            removeTokenFromBrowser() {

                utils.deleteLocalStorage('token');
                this.$store.commit('setHomePageInformation', {});
                this.$store.commit('setloginModal', true);
            },

            isMobileDevice() {
                return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
            },

            //get token from localStorage and check is expired
            redirectLoginOrMainPage(){

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    requests.homePageInformation(token, this.homePageInformationCallBack);
                    requests.get('rest/user/prefectures', (resp)=>{
                        this.$store.commit('setPrefectures', resp);
                    })
                }
                else {
                    this.$store.commit('setloginModal', true);
                }

            },

            homePageInformationCallBack(response) {
                utils.checkIfAllocator(response);
                this.homeInformation = response;
                this.$store.commit('setHomePageInformation', response);
				// if(response.bookInfoAlert===true){
				// 	console.log('inside')
				// 	this.$store.commit('setBookInfoAlert', true);
				// }else{
				this.$store.commit('setBookInfoAlert', response.bookInfoAlert);
				// }
                var token = utils.getLocalStorage('token');
                console.log('123123')
                if (token != null) {
                    requests.getYears(token, this.getYearsCallBack);
                }
                else {
                    this.$store.commit('setloginModal', true);
                }

            },

            getYearsCallBack(response) {


                this.$store.commit('setYearsFixed', response.yearsList);
                // var dataYear = [];
                // for (var i = 0;i < response.eudoxusPeriodDTOList.length; i++) {
                //     dataYear.push(response.eudoxusPeriodDTOList[i].year)
                // }

                var setYears = [];
                var years = response.yearsMapResp;
                for (var year in years) {
                    setYears.push(
                        {label: years[year],
                        value: Number(year)}
                    )
                }
                setYears.reverse();
                this.$store.commit('setActiveYear', response.activeYear);
                this.$store.commit('setEditedYear', response.editedYear);
                this.$store.commit('setYears', setYears);
                this.$store.commit('setYearsFixed', response.yearsList);
                // this.$store.commit('setAcademicYears', dataYear);
                this.$store.commit('setLoadingModal', false);
                // utils.checkpublisherHistory(this.homeInformation);
                if(this.homeInformation.eudoxusMembershipModal){
                    this.$store.commit('setParticipationModal', true);
                }
            },


        //    reCreate navication Path when login
            reCreateNavigationPath() {

                if (this.navigationPath != '/') {
                    this.navigationPath = '/'
                }
            },
        },

        created() {

            this.redirectLoginOrMainPage();
            if (window.performance) {
                // console.info("window.performance works fine on this browser");
            }
            if (performance.navigation.type == 1) {
                this.$router.push({path: '/'})
            } else {
                // console.info( "This page is not reloaded");
            }
            eventBus.$on('reCreateNavigationPath', () => {
                this.reCreateNavigationPath();
            })
        },

        watch:{
            '$route' (to, from){
                if (to.path != this.navigationPath) {
                    this.navigationPath = to.path;
                }
            }
        },
    };
</script>

<style>

    .v-btn {
        text-transform: none;
    }

    .v-data-table-header th {
        white-space: nowrap !important;
    }
</style>
